var _path, _path2, _path3, _rect, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPdfFile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#2b65c1",
    d: "M60.94,45.66A1,1,0,0,0,60,45H48a1,1,0,0,0-1,1V56a1,1,0,0,0,1.64.7681l12-10A1,1,0,0,0,60.94,45.66Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#d6e0f0",
    d: "M23,25V45H48a1.0029,1.0029,0,0,1,1,1V61a1.0029,1.0029,0,0,1-1,1H4a1.0029,1.0029,0,0,1-1-1V17a1.0327,1.0327,0,0,1,.29-.71l14-14A1.0327,1.0327,0,0,1,18,2H48a1.0029,1.0029,0,0,1,1,1V24a1.0029,1.0029,0,0,1-1,1Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M49,46v5H18a1.0029,1.0029,0,0,1-1-1V28a1.0029,1.0029,0,0,1,1-1h4V46Z",
    opacity: 0.15
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 24,
    x: 21,
    y: 23,
    fill: "#4d80e4",
    rx: 1
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#8d93ab",
    d: "M19,2V17a1.0029,1.0029,0,0,1-1,1H3V17a1.0327,1.0327,0,0,1,.29-.71l14-14A1.0327,1.0327,0,0,1,18,2Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#f1f3f8",
    d: "M34 29H28a1 1 0 0 0-1 1V40a1 1 0 0 0 2 0V37h5a1 1 0 0 0 1-1V30A1 1 0 0 0 34 29zm-1 6H29V31h4zM41 29H38a1 1 0 0 0-1 1V40a1 1 0 0 0 1 1h3a4.0039 4.0039 0 0 0 4-4V33A4.0039 4.0039 0 0 0 41 29zm2 8a2.0027 2.0027 0 0 1-2 2H39V31h2a2.0027 2.0027 0 0 1 2 2zM54 29H48a1 1 0 0 0-1 1V40a1 1 0 0 0 2 0V36h4a1 1 0 0 0 0-2H49V31h5a1 1 0 0 0 0-2z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdfFile);
export default __webpack_public_path__ + "static/media/pdf-file.109a599bb563a5fd5670d58c519c7d57.svg";
export { ForwardRef as ReactComponent };